/* Article table of contents. Built at runtime from the article body's
   own H2 headings (never hand-maintained), so it works for any article:
   - reads .up-article__body h2, slugifies each into an anchor id
   - renders one plain-text link per heading into the TOC list
   - smooth-scrolls to the heading on click
   - highlights the currently visible section via IntersectionObserver */

(function () {
  function slugify(text, used) {
    var base = text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');

    if (!base) {
      base = 'section';
    }

    var slug = base;
    var i = 1;

    while (used[slug]) {
      i += 1;
      slug = base + '-' + i;
    }

    used[slug] = true;
    return slug;
  }

  document.querySelectorAll('.up-article').forEach(function (section) {
    var toc = section.querySelector('[data-up-toc]');
    var list = section.querySelector('[data-up-toc-list]');
    var body = section.querySelector('[data-up-article-body]');

    if (!toc || !list || !body) {
      return;
    }

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));

    if (headings.length === 0) {
      toc.hidden = true;
      return;
    }

    var used = {};
    var entries = [];

    headings.forEach(function (heading) {
      if (heading.id) {
        used[heading.id] = true;
      } else {
        heading.id = slugify(heading.textContent, used);
      }

      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.className = 'up-article__toc-link';
      link.textContent = heading.textContent;
      item.className = 'up-article__toc-item';
      item.appendChild(link);
      list.appendChild(item);
      entries.push({ heading: heading, link: link });

      link.addEventListener('click', function (event) {
        event.preventDefault();
        heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + heading.id);
        }
      });
    });

    function setActive(heading) {
      entries.forEach(function (entry) {
        entry.link.classList.toggle('is-active', entry.heading === heading);
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (observerEntries) {
          var visible = observerEntries
            .filter(function (entry) {
              return entry.isIntersecting;
            })
            .sort(function (a, b) {
              return a.boundingClientRect.top - b.boundingClientRect.top;
            });

          if (visible.length > 0) {
            setActive(visible[0].target);
          }
        },
        { rootMargin: '-15% 0px -70% 0px', threshold: 0 }
      );

      headings.forEach(function (heading) {
        observer.observe(heading);
      });
    }

    setActive(headings[0]);
  });
})();
